"use client";

import * as React from "react";

/**
 * Simple markdown renderer for policy/terms text.
 * Handles headers, bold, bullet points, and &nbsp; entities.
 */
export function RenderMarkdown({ content }: { content: string }) {
  const cleaned = content.replace(/&nbsp;/g, "\u00A0");
  const lines = cleaned.split("\n");

  return (
    <div className="space-y-2">
      {lines.map((line, index) => {
        if (line.startsWith("### ")) {
          return (
            <h4 key={index} className="font-semibold text-foreground mt-4">
              {renderInline(line.replace("### ", ""))}
            </h4>
          );
        }
        if (line.startsWith("## ")) {
          return (
            <h3 key={index} className="font-semibold text-lg text-foreground mt-4">
              {renderInline(line.replace("## ", ""))}
            </h3>
          );
        }
        if (line.startsWith("# ")) {
          return (
            <h2 key={index} className="font-bold text-xl text-foreground mt-4">
              {renderInline(line.replace("# ", ""))}
            </h2>
          );
        }
        if (line.startsWith("- ") || line.startsWith("* ")) {
          return (
            <li key={index} className="text-muted-foreground ml-4">
              {renderInline(line.replace(/^[-*] /, ""))}
            </li>
          );
        }
        if (line.trim() === "") {
          return <div key={index} className="h-2" />;
        }
        return (
          <p key={index} className="text-muted-foreground">
            {renderInline(line)}
          </p>
        );
      })}
    </div>
  );
}

function renderInline(text: string): React.ReactNode {
  if (!text.includes("**")) return text;

  const parts = text.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <strong key={i} className="font-semibold text-foreground">
        {part}
      </strong>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );
}
